<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crt"><a class="page" id="piv"></a>NEW YORK UNIVERSITY PRESS</p>
<p class="crtf">New York</p>
<p class="crt"><a class="url" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="crtf">© 2019 by New York University</p>
<p class="crt">All rights reserved</p>
<p class="crtf">References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.</p>
<p class="crtf">A previous, modified version of Chapter 15 was published as “Loving the Stranger and the Fall of Agriprocessors” in <i>Jewish Ethics in a Post-Madoff World</i>, by Moses Pava, published in 2011 by Palgrave Macmillan. Reproduced with permission of SNCSC.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Gross, Aaron S., editor. | Myers, Jody Elizabeth, 1954– editor. | Rosenblum, Jordan, 1979– editor.</p>
<p class="cip">Title: Feasting and fasting : the history and ethics of Jewish food / with a foreword by Hasia R. Diner and an afterword by Jonathan Safran Foer ; edited by Aaron S. Gross, Jody Myers, and Jordan D. Rosenblum.</p>
<p class="cip">Description: New York : New York University Press, [2019] | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2019015755 | ISBN 9781479899333 (cl : alk. paper) | ISBN 9781479827794 (pb : alk. paper)</p>
<p class="cip">Subjects: LCSH: Jews—Food—History. | Jewish cooking—History. | Jewish ethics.</p>
<p class="cip">Classification: LCC TX724 .F3715 2019 | DDC 641.5/676—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2019015755" target="_blank">https://lccn.loc.gov/2019015755</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nyugross0003.vue?d0d65658